"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationLocales = void 0;
exports.TranslationLocales = {
    "decimalSeparator": true,
    "language": true,
    "thousandSeparator": true
};
